import { Injectable } from '@angular/core';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';
import { Platform } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root',
})
export class PhoneService {
  constructor(
    private _callNumber: CallNumber,
    private _platform: Platform,
    private _logger: NGXLogger,
  ) {}

  makePhoneCall(number: string): void {
    number = number.replace(/\D/g, '');
    if (this._platform.is('capacitor')) {
      this._callNumber
        .callNumber(number, true)
        .then(() => this._logger.log('Launched dialer!'))
        .catch((err) => this._logger.error('Error launching dialer', err));
    } else {
      window.open(`tel:${number}`);
    }
  }
}
